import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'antd';
import BaseModal from './BaseModal';

const ConfirmButton = ({
  title,
  onConfirm,
  disabled = false,
  loading,
  icon,
  buttonText,
  buttonType = 'primary',
  className,
  disabledPopover,
  sizeButton = 'default',
  children
}) => {
  const [visible, setVisible] = useState(false);
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);

  const onHide = () => setVisible(false);
  const onClick = () => {
    onConfirm();
    onHide();
  };

  useEffect(() => {
    if (pending && !loading) {
      pendingRef.current = false;
      setPending(false);
    }
  }, [pending, loading]);

  return (
    <>
      <BaseModal
        title={title}
        onClick={onClick}
        disabled={disabledPopover || disabled}
        visible={visible}
        onHide={onHide}
        loading={loading}
      >
        {children}
      </BaseModal>
      <Button
        type={buttonType}
        className={`confirm-btn text-sm !flex items-center justify-center ${className}`}
        disabled={disabled}
        loading={loading || pending}
        icon={icon}
        onClick={(event) => {
          event.stopPropagation();
          if (disabledPopover) {
            if (loading || pendingRef.current) return;
            pendingRef.current = true;
            setPending(true);
            onConfirm();
            return;
          }
          setVisible(true);
        }}
        size={sizeButton}
      >
        {buttonText}
      </Button>
    </>
  );
};

export default ConfirmButton;
